// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Wg_I","info":"Note_info__2c5Vx","note":"Note_note__1A8JR","actions":"Note_actions__2qLcK"};